import { Tooltip } from '@material-ui/core';
import React, { Component } from 'react';
import { ReactSVG } from 'react-svg';
import InfoIcon from '../../../images/icons/info_icon.svg'
import palette from '../../../theme/palette';

export default class InfoTooltip extends Component {
    constructor(props) {
        super(props);

        this.state = {
            text: props.text,
        }
    }

    render() {
        return (
            <Tooltip title={this.state.text}>
                <ReactSVG src={InfoIcon} beforeInjection={(svg) => {
                    svg.setAttribute('fill', palette.primary.main)
                    svg.setAttribute('width', '20px')
                    svg.setAttribute('height', '20px')
                }}></ReactSVG>
            </Tooltip>
        );
    }
}
